
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function VerifyShopPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [status, setStatus] = useState('verifying');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/owners/verify?token=${token}`)
        .then(res => res.json())
        .then(data => {
          if (data.verified) {
            setStatus('success');
            setTimeout(() => {
              navigate('/shop-profile?token=' + token);
            }, 2000); // Redirect after 2 seconds
          } else {
            setStatus('failed');
          }
        })
        .catch(() => setStatus('failed'));
    } else {
      setStatus('failed');
    }
  }, [location, navigate]);

  const cardStyle = {
    padding: isMobile ? '20px' : '40px',
    maxWidth: isMobile ? '95%' : '500px',
    margin: '0 auto',
    textAlign: 'center'
  };

  const headingStyle = {
    fontSize: isMobile ? '20px' : '24px',
    marginBottom: '16px'
  };

  const textStyle = {
    fontSize: isMobile ? '14px' : '16px'
  };

  if (status === 'verifying') {
    return <div className="form-card" style={cardStyle}><h2 style={headingStyle}>Verifying...</h2></div>;
  }
  if (status === 'success') {
    return <div className="form-card" style={cardStyle}><h2 style={headingStyle}>Verification Successful!</h2><p style={textStyle}>Redirecting to shop profile...</p></div>;
  }
  return <div className="form-card" style={cardStyle}><h2 style={headingStyle}>Verification Failed</h2><p style={textStyle}>The link is invalid or expired.</p></div>;
}

export default VerifyShopPage;